import axios from 'axios'
import { put, call, takeLatest } from 'redux-saga/effects'
import apiConfig from '@services/apiConfig'

import {
  GET_BENEFICIARIES_TO_SELECT,
  GET_BENEFICIARIES_WITH_COLLECTION,
  setBeneficiaries,
  setBeneficiariesToSelect,
  GET_REPORT_DATA,
  GET_REPORT_TO_INSURANCE_DATA,
  SAVE_BENEFICIARY,
  setReport,
  GET_CSV_DATA,
  CHECK_BENEFICIARIES_READ,
  setBeneficiariesChecked,
  SAVE_BENEFICIARIES_EXAMS,
  GET_COUNT_BENEFICIARIES_WITH_COLLECTION,
  setCountBeneficiariesWithCollection,
  GET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME,
  setCountBeneficiariesByCompanyOrProgramme,
  GET_BENEFICIARIES_TO_MESSAGE,
  setBeneficiariesToMessage,
  GET_BENEFICIARIES_TO_ACCESS_CONTROL,
  setBeneficiariesToAccessControl,
} from '@actions/beneficiary'

import { getDateStringFromFormattedDateStr } from '@util/timeUtil'
import { onlyNumbersMask } from '@util/stringUtil'
import showToast from '@util/ToastUtil'

import errorHandler from '../errorHandler'

const classPrefix = '/beneficiaries'

function* getCountBeneficiariesWithCollection({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${
        apiConfig.prefix + classPrefix
      }/count-beneficiaries-with-collection`,
      params,
    })
    yield put(setCountBeneficiariesWithCollection(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getBeneficiariesToMessage({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/with-or-without-collection`,
      params: {
        ...params,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    })
    yield put(setBeneficiariesToMessage(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getReport({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix + classPrefix}/report-data`,
      data: {
        ...params,
        birthdate: getDateStringFromFormattedDateStr(params.birthdate),
      },
    })
    yield put(setReport(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getBeneficiariesToSelect({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/to-select`,
      params,
    })
    yield put(setBeneficiariesToSelect(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

// with or without collection
function* getBeneficiariesWithCollection({ params, callback }) {
  try {
    const {
      startDate,
      endDate,
      beneficiaryAge,
      ...restParams
    } = params

    const requestParams = {
      ...restParams,
      beneficiaryAge: beneficiaryAge || null,
    }

    if (startDate) {
      requestParams.startDate = startDate
    }
    if (endDate) {
      requestParams.endDate = endDate
    }

    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/with-or-without-collection`,
      params: requestParams,
    })

    yield put(setBeneficiaries(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getCsvData({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/with-or-without-collection`,
      params: {
        ...params,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    })
    callback && callback(response.data.list)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getReportToInsurance({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/insurance/report-data`,
      params,
    })
    yield put(setReport(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* saveBeneficiary({ data, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix + classPrefix}`,
      data: {
        ...data,
        phoneNumber: onlyNumbersMask(data.phoneNumber),
        birthdate: getDateStringFromFormattedDateStr(data.birthdate),
        cpf: onlyNumbersMask(data.cpf),
      },
    })
    callback && callback(response.data)
    showToast('success', 'Beneficiário cadastrado com sucesso')
  } catch (error) {
    callback && callback(error.response.data)
    errorHandler(error)
  }
}

function* checkBeneficiariesRead({ params }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/to-check`,
      params,
    })
    yield put(setBeneficiariesChecked(response.data))
  } catch (error) {
    errorHandler(error)
  }
}

function* saveBeneficiariesExams({ data, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix + classPrefix}/save-exams`,
      data,
      headers: {
        'content-type': 'multipart/form-data',
      },
    })
    callback && callback(response.data)
    showToast('success', 'Exames salvos com sucesso')
  } catch (error) {
    errorHandler(error)
  }
}

function* getCountBeneficiariesByCompanyOrProgramme({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${
        apiConfig.prefix + classPrefix
      }/count-beneficiaries-by-companyid-or-programmeid`,
      params: {
        ...params,
      },
    })
    yield put(setCountBeneficiariesByCompanyOrProgramme(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

// worker
function* getBeneficiariesToAccessControl({ callback, params }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix}/accessControl`,
      params: {
        page: params.page - 1,
        limit: params.limit,
      },
    })
    yield put(setBeneficiariesToAccessControl(response.data.content))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    // seu errorHandler se existir:
    // errorHandler(error)
  }
}

// watcher
export function* getBeneficiariesToAccessControlSaga() {
  yield takeLatest(
    GET_BENEFICIARIES_TO_ACCESS_CONTROL,
    getBeneficiariesToAccessControl
  )
}

export function* getReportSaga() {
  yield takeLatest(GET_REPORT_DATA, getReport)
}

export function* getBeneficiariesToSelectSaga() {
  yield takeLatest(GET_BENEFICIARIES_TO_SELECT, getBeneficiariesToSelect)
}

export function* getBeneficiariesWithCollectionSaga() {
  yield takeLatest(
    GET_BENEFICIARIES_WITH_COLLECTION,
    getBeneficiariesWithCollection
  )
}

export function* getCsvDataSaga() {
  yield takeLatest(GET_CSV_DATA, getCsvData)
}

export function* getReportToInsuranceSaga() {
  yield takeLatest(GET_REPORT_TO_INSURANCE_DATA, getReportToInsurance)
}

export function* saveBeneficiarySaga() {
  yield takeLatest(SAVE_BENEFICIARY, saveBeneficiary)
}

export function* checkBeneficiariesReadSaga() {
  yield takeLatest(CHECK_BENEFICIARIES_READ, checkBeneficiariesRead)
}

export function* saveBeneficiariesExamsSaga() {
  yield takeLatest(SAVE_BENEFICIARIES_EXAMS, saveBeneficiariesExams)
}

export function* getCountBeneficiariesWithCollectionSaga() {
  yield takeLatest(
    GET_COUNT_BENEFICIARIES_WITH_COLLECTION,
    getCountBeneficiariesWithCollection
  )
}

export function* getCountBeneficiariesByCompanyOrProgrammeSaga() {
  yield takeLatest(
    GET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME,
    getCountBeneficiariesByCompanyOrProgramme
  )
}

export function* getBeneficiariesToMessageSaga() {
  yield takeLatest(GET_BENEFICIARIES_TO_MESSAGE, getBeneficiariesToMessage)
}
